import _ from "lodash";

export const CHANNEL_SOURCE_CHANGED = "source-changed";

const sampleSchema = { // eslint-disable-line
	id: "ruleId",
	sourceId: "calcId",
	actions: [
		{
			type: "valueAssignment",
			// source: "result.visible" // Not necessary
			target: "['currentChecklist', 'overrides','varId','visible']"
		}
	]
};

export default class RulesEngine {
	constructor(rules, capabilities = null, pubSubProvider = null) {
		this.setRules(rules);
		this.setCapabilities(capabilities);
		this.setPubSubProvider(pubSubProvider);
	}

	setPubSubProvider(pubSubProvider) {
		this.pubSubProvider = pubSubProvider;
		if (this.pubSubProvider && !this.variableStateChangeSubscriptionChannelToken) {
			this.variableStateChangeSubscriptionChannelToken = this.pubSubProvider.subscribe(CHANNEL_SOURCE_CHANGED, (msg, data) => { this.handleEvent(data); });
		}
	}

	setRules(rules) {
		this.rules = rules;
		if (rules) {
			this.sourceIdToRule = getSourceIdToRuleMao(rules);
		}
	}

	processInput(incomingData) {
		return this.handleEvent(incomingData);
	}

	handleEvent(incomingData) {
		const results = [];
		_.keys(incomingData).forEach(key => {
			if (this.sourceIdToRule && this.sourceIdToRule.hasOwnProperty(key)) {
				results.push(this.executeRule(this.sourceIdToRule[key], incomingData[key]));
			}
		});
		return results;
	}

	setCapabilities(capabilities) {
		this.capabilities = {};
		if (capabilities) {
			this.capabilities = capabilities;
		}
	}

	addCapability(actionType, func) {
		if (!_.isString(actionType) || !_.isFunction(func)) {
			throw new Error("Expecting actionType to be a String and func to be a function.");
		}
		this.capabilities[actionType] = func;
	}

	getCapabilityForActionType(actionType) {
		let result = nullCapability;
		if (this.capabilities[actionType]) {
			result = this.capabilities[actionType];
		}
		return result;
	}

	executeRule(rule, data) {

		// Just adding different aliases to the scope, not sure what the rule will use.
		const result = data; //eslint-disable-line
		const input = data; //eslint-disable-line

		rule.actions.forEach(action => {
			switch (_.toLower(action.type)) {
			case "valueassignment": {
				const value = action.source ? action.source.indexOf("${") !== -1 ? eval(`\`${action.source}\``) : eval(action.source) : data;
				this.getCapabilityForActionType(action.type)(action.target, value);
				break;
			}
			default: {
				const capability = this.getCapabilityForActionType(action.type);
				if (capability === nullCapability) {
					throw new Error(`Unable to find a capability that supports action type: ${action.type}`);
				} else {
					capability(rule, data);
				}
			}
			}
		});
		return rule;
	}
}


function nullCapability(...args) {
	console.log("FALLBACK NULL CAPABILITY: ", args);
}
function getSourceIdToRuleMao(rules) {
	const result = {};
	if (rules && _.isArray(rules)) {
		rules.forEach(rule => {
			if (rule.sourceId) {
				result[rule.sourceId] = rule;
			}
		});
	}
	return result;
}